import { getGameConfig } from '../../../config/gameConfig';

// TODO: there should be different capacity for stone house that it is for wooden house
export function getHouseCapacity(): number {
    return Math.max(1, Math.floor(getGameConfig().defaults.populationPerHouse));
}
